import * as ng from 'angular';

import { L10nService } from './l10n.service';

ng.module('e360').filter('languageName', languageNameFilter);

languageNameFilter.$inject = ['l10n'];
export function languageNameFilter(l10n:L10nService) {
   return languageName;

   function languageName(code:string, opts = {native: false}) {
      return l10n.getName(code, opts);
   }
}
